import { render, staticRenderFns } from "./Bracket4.vue?vue&type=template&id=5c6cc6fc&scoped=true&"
import script from "./Bracket4.vue?vue&type=script&lang=js&"
export * from "./Bracket4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6cc6fc",
  null
  
)

export default component.exports